import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import SprintDetail from '../../../components/Admin/Sprints/SprintDetail';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const SprintDetailContainer = (props) => (
  <ApolloProvider client={client}>
    <SprintDetail {...props} />
  </ApolloProvider>
);

export default SprintDetailContainer;


